var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7528_9536",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(180 12 12)",
    fill: "#626262"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7528_9536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1L9 6L4 11L3.1125 10.1125L7.225 6L3.1125 1.8875L4 1Z",
    fill: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.9b67bbe4562789df49f6054a3f961292.svg";
export { ForwardRef as ReactComponent };